import { sanitizeItemStatusLabel } from "#/utils/StringUtils";

export interface FixedStatusOption {
  value: string;
  label: string;
}

/**
 * Options for a single-fixed scanner's status dropdown: the client's allowed
 * statuses, plus the scanner's current status when it is no longer allowed —
 * flagged, so the user sees the problem and can pick a valid one instead of
 * facing a blank field.
 */
export const buildFixedStatusOptions = (
  allowedStatuses: readonly string[],
  currentStatus: string | null | undefined,
  notEnabledSuffix: string,
): FixedStatusOption[] => {
  const options: FixedStatusOption[] = allowedStatuses.map((status) => ({
    value: status,
    label: sanitizeItemStatusLabel(status),
  }));

  const current = typeof currentStatus === "string" ? currentStatus.trim() : "";
  if (current !== "" && !allowedStatuses.includes(current)) {
    options.push({
      value: current,
      label: `${sanitizeItemStatusLabel(current)} ${notEnabledSuffix}`,
    });
  }

  return options;
};
